import React from 'react';
import { IconChevronRight } from 'lib/icons';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { removeOutline, transitionAnimation } from './../../core';

const StyledPanelChevron = styled(IconChevronRight).withConfig({
  shouldForwardProp: (prop) => !['isOpen'].includes(prop),
})`
  ${transitionAnimation('transform')}
  ${removeOutline}
    align-self: start;
  display: inline-flex;
  fill: ${({ theme }) => theme.color.gray[700].value};
  flex-shrink: 0;
  transform: rotate(90deg);
  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotate(270deg);
    `}
`;

const PanelChevron = ({ isOpen = false, ...props }) => <StyledPanelChevron {...{ isOpen }} {...props} />;

PanelChevron.propTypes = {
  /** If true, PanelChevron will rotate to indicate state "open" */
  isOpen: PropTypes.bool,
};

export { PanelChevron };
